import React from 'react';
import { Button, ButtonProps, SxProps, Theme } from '@mui/material';
import styled from '@emotion/styled';
import MuiLoader from './Loader';

export interface CustomButtonProps extends ButtonProps {
    title?: string;
    onClick?: React.EventHandler<any>;
    width?: string | number;
    height?: string | number;
    fontSize?: number;
    backgroundColor?: string; // Add backgroundColor prop
    sx?: SxProps<Theme>;
    type?: 'button' | 'submit' | 'reset' | undefined;
    loading?: boolean;
    disabled?: boolean;
    children?: React.ReactElement | React.ReactNode;
}

interface PrimaryButtonProps {
    width?: string | number;
    fontSize?: number;
    variant?: string;
    height?: string | number;
    sx?: any;
    color?: string;
}

const PrimaryButton = styled(Button)(({ width, fontSize, variant, height, sx, color }: PrimaryButtonProps) => ({
    // ... (existing styles)
    boxShadow: 'none',
    p: '6px 12px',
    height: height || 50,
    '&:disable': {
        backgroundColor: '#9CA3AF',
    },
    ...(variant === 'outlined' && {
        color: '#142456',
        borderColor: '#142456',
    }),
    ...(variant === 'contained' && {
        color: color === 'error' ? 'white' : '',
        '&:hover': {
            backgroundColor: color === 'error' ? '' : '#1976d2',
        },
    }),
    ...(variant === 'text' && {
        width: 'fit-content',
        '&:hover': {},
    }),
    textTransform: 'capitalize',
    fontSize,
    width: !width && variant === 'text' ? 'fit-content' : width,
    ...sx,
}));

export default function CustomButton({
    title,
    onClick,
    sx,
    backgroundColor,
    width,
    fontSize,
    loading,
    disabled,
    children,
    ...props
}: CustomButtonProps) {
    return (
        <PrimaryButton
            onClick={onClick}
            sx={sx}
            variant="contained"
            width={width}
            fontSize={fontSize || 18}
            disabled={loading || disabled}
            {...props}
        >
            {loading ? <MuiLoader loading={loading} size={30}></MuiLoader> : children || title}
        </PrimaryButton>
    );
}
